import { __extends, __rest } from "tslib";
import React from "react";
import PropTypes from "prop-types";
import styles from "./PnmacAvatar.styles.js";
import { StyleSheet, View } from "react-native";
import PnmacChatAvatar from "../ChatAvatar/PnmacChatAvatar";
import { isSameUser, isSameDay } from "../utils";
var PnmacAvatar = /** @class */function (_super) {
  __extends(PnmacAvatar, _super);
  function PnmacAvatar() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PnmacAvatar.prototype.renderAvatar = function () {
    if (this.props.renderAvatar) {
      var _a = this.props,
        renderAvatar = _a.renderAvatar,
        avatarProps = __rest(_a, ["renderAvatar"]);
      return this.props.renderAvatar(avatarProps);
    }
    return /*#__PURE__*/React.createElement(PnmacChatAvatar, {
      avatarStyle: StyleSheet.flatten([styles[this.props.position].image]),
      user: this.props.currentMessage.user
    });
  };
  PnmacAvatar.prototype.render = function () {
    if (isSameUser(this.props.currentMessage, this.props.nextMessage) && isSameDay(this.props.currentMessage, this.props.nextMessage)) {
      return /*#__PURE__*/React.createElement(View, {
        style: [styles[this.props.position].container, this.props.containerStyle[this.props.position]]
      }, /*#__PURE__*/React.createElement(PnmacChatAvatar, {
        avatarStyle: StyleSheet.flatten([styles[this.props.position].image])
      }));
    }
    return /*#__PURE__*/React.createElement(View, {
      testID: "avatar",
      style: [styles[this.props.position].container, this.props.containerStyle[this.props.position], this.props.currentMessage && this.props.currentMessage.iconOnTopLeft ? {
        zIndex: 1
      } : {}]
    }, this.renderAvatar());
  };
  return PnmacAvatar;
}(React.Component);
PnmacAvatar.defaultProps = {
  position: "left",
  currentMessage: {
    user: null
  },
  nextMessage: {},
  containerStyle: {}
};
PnmacAvatar.propTypes = {
  position: PropTypes.oneOf(["left", "right"]),
  currentMessage: PropTypes.object,
  nextMessage: PropTypes.object,
  containerStyle: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string])
};
export default PnmacAvatar;